export default __webpack_public_path__ + "static/media/docs.239353aa.svg";